import posthog from 'posthog-js'

interface EventProperties {
  [key: string]: any
}

const getDarkModePreference = (): boolean => {
  if (typeof window === 'undefined') return false
  return window?.matchMedia?.('(prefers-color-scheme: dark)')?.matches
}

export const capturePosthogEvent = (eventName: string, properties?: EventProperties) => {
  if (typeof window !== 'undefined' && posthog?.__loaded) {
    posthog.capture(eventName, {
      $current_url: window?.location?.href,
      $pathname: window?.location?.pathname,
      isDarkMode: getDarkModePreference(),
      ...properties,
    })
  }
}

export const logGenericPosthogEvent = (moduleName: string, pageData?: any) => {
  capturePosthogEvent('On Submit validation Trigger', {
    moduleName: moduleName || '',
    pageData: pageData || {},
  })
}

export const logCustomPosthogEvent = (eventName: string, moduleName: string, pageData?: any) => {
  capturePosthogEvent(eventName, {
    moduleName: moduleName || '',
    pageData: pageData || {},
  })
}

export const capturePageView = (path: string, properties?: EventProperties) => {
  capturePosthogEvent('$pageview', {
    path,
    ...properties,
  })
}

export const capturePageLoaded = (pageName: string, pageData?: any) => {
  capturePosthogEvent(`${pageName} Page Loaded`, {
    pageData: pageData || {},
  })
}

export const captureButtonClick = (buttonName: string, properties?: EventProperties) => {
  capturePosthogEvent(`Clicked ${buttonName}`, properties)
}

export const identifyUser = (userId: string, properties?: EventProperties) => {
  if (typeof window !== 'undefined' && posthog?.__loaded) {
    posthog.identify(userId, properties)
  }
}

export const registerProperties = (properties: EventProperties) => {
  if (typeof window !== 'undefined' && posthog?.__loaded) {
    posthog.register(properties)
  }
}

export const unregisterProperty = (propertyName: string) => {
  if (typeof window !== 'undefined' && posthog?.__loaded) {
    posthog.unregister(propertyName)
  }
}

export const isPosthogReady = (): boolean => {
  return typeof window !== 'undefined' && !!posthog?.__loaded
}
